<template>
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon">📋</div>
      <div class="stat-content">
        <div class="stat-label">Total Requests</div>
        <div class="stat-value">{{ stats.totalRequests }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon">⏳</div>
      <div class="stat-content">
        <div class="stat-label">Pending</div>
        <div class="stat-value">{{ stats.pendingRequests }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon">💻</div>
      <div class="stat-content">
        <div class="stat-label">Inventory</div>
        <div class="stat-value">{{ stats.totalEquipment }}</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon">🚀</div>
      <div class="stat-content">
        <div class="stat-label">Delivered</div>
        <div class="stat-value">{{ stats.deliveredEquipment }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable no-undef */
interface Stats {
  totalRequests: number
  pendingRequests: number
  deliveredEquipment: number
  totalEquipment: number
}

interface Props {
  stats: Stats
}

withDefaults(defineProps<Props>(), {
  stats: () => ({
    totalRequests: 0,
    pendingRequests: 0,
    deliveredEquipment: 0,
    totalEquipment: 0
  })
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: var(--white, #ffffff);
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stat-icon {
  font-size: 2.5rem;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--text-light, #666666);
  margin-bottom: 0.25rem;
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--primary-color, #2c4a6b);
  font-family: 'Poppins', sans-serif;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
